import { useSelector } from 'react-redux'

export const useAuth = () => (
  useSelector(state => state.auth)
)

export const useUserInfo = () => (
  useSelector(state => state.auth?.userInfo)
)